import { types } from "mobx-state-tree"

export const Prediction = types
    .model({
        date: types.string,
        value: types.number,
    })